import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
//import logo from "../../images/logo.svg";
import "./styles.scss";
import { Link, useHistory, useLocation } from "react-router-dom";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchUserEmailLogin, fetchUserGoogleLogin } from "../../redux/actions/authentication";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";



import isEmpty from "../../utils/isEmpty";
import storeId from "../../config/storeId";
import Auth from "../../config/auth";
import { CLIENT_ID, BASE_URL } from "../../redux/constants";

import GoogleLogin from "react-google-login";
import Axios from "axios";

const Login = (props) => {
  const store = storeId();
  let history = useHistory();
  let location = useLocation();
  const { buttonLabel, className } = props;
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    console.log(form);
  }, [form]);
  const [state, setState] = useState({});
  const [errors, setErrors] = useState({
    message: "",
    code: "",
    yesError: false,
  });

  function responseGoogle(res) {
    console.log(res);
    const data = { token: res.tokenId };
    handleGoogle(data);
  }

  function responseGoogleError(res) {
    console.log(res);
  }

  async function handleGoogle(data) {
    setLoading(true);
    try {
      const response = await Axios.post(
        `${BASE_URL}/users/google/login`,
        data
      );
      if (response.data.hasError) {
        NotificationManager.error(response.data.errors.message);
        setLoading(false);
      } else {
        const { user, token } = response.data.data;
        Auth.setToken(token, user);
        history.push(location.pathname);
        setLoading(false);
        NotificationManager.success(response.data.message);
        toggle();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const userData = {
      email: form.email,
      password: form.password,
      store_id: Auth.getStore(),
    };
    try {
      const response = await Axios.post(
        `${BASE_URL}/users/login/email`,
        userData
      );
      if (response.data.hasError) {
        // setErrors({ ...errors, ...props.user.errors.errors, yesError: true });
        setForm({ ...form, password: "" });
        NotificationManager.error(response.data.errors.message);
        setLoading(false);
      } else {
        const { user, token } = response.data.data;
        Auth.setToken(token, user);
        //console.log(user)
        
        history.push(location.pathname);
        //setErrors({ ...errors, yesError: false });
        setForm({ ...form, email: "", password: "" });
        setLoading(false);
        NotificationManager.success(response.data.message);
        toggle();
      }
    } catch (error) {
      console.log(error);
    }
  }
  // function handleSubmit(e) {
  //   e.preventDefault();
  //   setLoading(true);
  //   const userData = {
  //     email: form.email,
  //     password: form.password,
  //     store_id: Auth.getStore(),
  //   };
  //   props.fetchUserEmailLogin(userData);
  // }
  // function responseGoogle(res) {
  //   console.log(res);
  //   const data = { token: res.tokenId };
  //   props.fetchUserGoogleLogin(data);
  // }

  // function responseGoogleError(res) {
  //   console.log(res)
  // }
  // useEffect(() => {
  //   setLoading(false);

  //   if (!isEmpty(props.user.user)) {
  //     const { user } = props.user;
  //     if (!user.hasError) {
  //       setState(user.data);
  //       history.go("/");
  //       setErrors({ ...errors, yesError: false });
  //       setForm({ ...form, email: "", password: "" });
  //     }
  //   } else {
  //     if (props.user.errors.errors) {
  //       setErrors({ ...errors, ...props.user.errors.errors, yesError: true });
  //       setForm({ ...form, email: "", password: "" });
  //     }
  //   }
  // }, [props.user]);

  return (
    <div>
       <NotificationContainer />
      <Button className="login" size="sm" outline color="dark" onClick={toggle}>
        {buttonLabel}
      </Button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <div className="justify-content-center">
          <ModalHeader toggle={toggle} className="text-center">
            <div className="login-header">
              {/* <img src={logo} alt="logo" width="100" height="50" /> */}
              {store}
            </div>
          </ModalHeader>
          <ModalBody>
            <form
              className="text-center p-3"
              method="post"
              onSubmit={handleSubmit}
            >
              {errors.yesError && (
                <div className="alert alert-danger">{errors.message}</div>
              )}
              {!isEmpty(state.user) && (
                <div className="alert alert-success">
                  {props.user.user.message}
                </div>
              )}
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email address</label>
                <input
                  type="email"
                  name="email"
                  className="form-control login-input"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  autoFocus
                  required
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputPassword1">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control login-input"
                  id="exampleInputPassword1"
                  autoFocus
                  required
                  value={form.password}
                  onChange={(e) =>
                    setForm({ ...form, password: e.target.value })
                  }
                />
              </div>

              <div className="d-flex justify-content-between">
                <label>
                  <input type="checkbox" id="checkbox2" /> keep me Logged in
                </label>
                <Link to="/forgot-password">forgot password</Link>
              </div>

              <button
                type="submit"
                className="btn login-btn text-white"
                disabled={loading}
              >
                {loading ? "Loading..." : "Log In"}
              </button>
              <p>- or -</p>
              <GoogleLogin
                clientId={CLIENT_ID}
                // buttonText="Login"
                onSuccess={responseGoogle}
                onFailure={responseGoogleError}
                cookiePolicy={"single_host_origin"}
                render={(renderProps) => (
                  <button
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                    className="btn-google mb-3"
                  >
                    <i className="fa fa-google fa-lg" aria-hidden="true"></i>
                    <span>Continue with Google</span>
                  </button>
                )}
              />
            </form>
          </ModalBody>
        </div>
      </Modal>
    </div>
  );
};

Login.propTypes = {
  user: PropTypes.object.isRequired,
  fetchUserEmailLogin: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.emailLogin,
});

const pageActions = { fetchUserEmailLogin, fetchUserGoogleLogin };

export default connect(mapStateToProps, pageActions)(Login);
